import React, { useState, useEffect } from "react";
import { useRouter } from "./../util/router";
import NotFoundPage from "../components/general/NotFound";
import AlarmContent from "../components/alarms/AlarmContent";
import { useUser } from "../util/user";

function AlarmsPage() {
  const [hasAccess, setHasAccess] = useState(false);
  const router = useRouter();
  const userObj = useUser();

  useEffect(() => {
    // User is authenticated
    if (userObj != null) {
      // User has access to this page
      if (userObj.roles != null && userObj.roles.includes("alarms:_view"))
        setHasAccess(true);
    }
    else
      router.push("/solar/logout");

  }, [userObj]);
  return hasAccess ? <AlarmContent /> : <NotFoundPage />;
}

export default AlarmsPage;
